export const primaryColor = "#f97203";
export const secondaryColor = "#150578";
